import { useSize } from 'ahooks';

export const useHeaderHeight = (): number => {
  const total = useSize(
    document.querySelector('#page_header') as HTMLDivElement,
  );

  return total?.height || 0;
};

export const useBannerHeight = (): number => {
  const total = useSize(
    document.querySelector('#banner_wrapper') as HTMLDivElement,
  );

  return total?.height || 0;
};
